import { FunctionComponent } from 'react';

import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
} from '@kanda-libs/ks-design-library';

import RateRequestListPageBanner from './Banner';
import RateRequestListProvider from './context';

import RateRequestTable from '../RateRequestTable';

const RateRequestListPage: FunctionComponent = () => {
  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContent>
        <RateRequestListProvider>
          <RateRequestListPageBanner />
          <RateRequestTable />
        </RateRequestListProvider>
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default RateRequestListPage;
